import { type TextareaHTMLAttributes, useId } from 'react';

import { cn } from '@/utils/cn';

import { Field } from './Field';
import styles from './Field.module.css';
import { fieldDescriptionIds } from './field-ids';

export interface TextareaFieldProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  hint?: string | undefined;
  error?: string | undefined;
  fieldClassName?: string | undefined;
}

export function TextareaField({
  label,
  hint,
  error,
  id,
  required,
  rows = 3,
  className,
  fieldClassName,
  ...textareaProps
}: TextareaFieldProps) {
  const generatedId = useId();
  const textareaId = id ?? generatedId;

  return (
    <Field
      label={label}
      htmlFor={textareaId}
      hint={hint}
      error={error}
      required={required}
      className={fieldClassName}
    >
      <textarea
        id={textareaId}
        rows={rows}
        required={required}
        aria-invalid={error ? true : undefined}
        aria-describedby={fieldDescriptionIds(textareaId, hint, error)}
        className={cn(styles.input, styles.textarea, error && styles.invalid, className)}
        {...textareaProps}
      />
    </Field>
  );
}
